import { Link } from "react-router-dom";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <SEO title="Page Not Found" description="The page you're looking for could not be found." path="/404" />
      <PageHero eyebrow="404" title="Page Not Found" subtitle="Text goes here" crumbLabel="404" />
      <section className="bg-brand-black py-16 text-center">
        <Link to="/" data-testid="not-found-home-link" className="inline-flex items-center gap-2 bg-brand-purple px-7 py-4 font-subheading text-sm font-semibold uppercase tracking-wide text-white hover:bg-brand-purple-hover transition-colors">
          Back To Home
        </Link>
      </section>
    </div>
  );
}
